import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable, interval } from 'rxjs';
import { filter, takeUntil, withLatestFrom } from 'rxjs/operators';
import { CurrentUser } from 'src/app/authentication/models/current-user.interface';
import { getCurrentUser, getIsLoggedIn } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import { getExtensionPrivileges, getPresenceContactPrivileges } from 'src/app/privileges/privileges.selector';
import { PresenceContactFilterOptions } from './models/presence-contact-filter-option';
import { EditPresenceContactPrivileges, PresenceContactPrivileges } from './models/presence-contact-privileges';
import { PresenceContactRegisterOptions } from './models/presence-contact-register-options';
import { PresenceContactRegisterListItem } from './models/presence-contact-register-results.model';
import {
   presenceContactRegisterAdapterActions,
   presenceContactRegisterInitialFilter,
   refreshList,
} from './state/presence-contact-register.actions';
import * as presenceContactRegisterReducer from './state/presence-contact-register.reducer';

@Directive()
export class PresenceContactRegister
   extends Register<PresenceContactRegisterListItem, PresenceContactRegisterOptions, OrderingOption>
   implements OnInit, OnDestroy
{
   columns: string[];

   filters: PresenceContactFilterOptions[];

   entityName = 'Presence Contact';

   presenceContactPrivileges$: Observable<PresenceContactPrivileges>;
   editPresenceContactPrivileges$: Observable<EditPresenceContactPrivileges>;
   currentUser$: Observable<CurrentUser | null>;

   constructor(public store: Store) {
      super(store, presenceContactRegisterReducer.selectors, presenceContactRegisterAdapterActions);
      this.presenceContactPrivileges$ = store.pipe(select(getExtensionPrivileges));
      this.editPresenceContactPrivileges$ = store.pipe(select(getPresenceContactPrivileges));
      this.currentUser$ = store.pipe(select(getCurrentUser));
   }

   ngOnInit() {
      this.store.dispatch(presenceContactRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
      interval(120 * 1000)
         .pipe(
            withLatestFrom(this.store.pipe(select(getIsLoggedIn))),
            filter(([, isLoggedIn]) => isLoggedIn),
            takeUntil(this.destroyed$)
         )
         .subscribe(() => {
            this.store.dispatch(refreshList());
         });
   }
}
